import * as Yup from 'yup';

export const ProfileEditPositionFormValidationSchema = Yup.object().shape({
  OfficeLocationID: Yup.object()
    .nullable()
    .required('Office location field is required'),

  Description: Yup.string()
    .nullable()
    .max(2000, 'You have exceeded the maximum number of 2000 characters'),
});
